import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ICompany, IListByFilterEmpresas } from 'src/app/pages/companies/models/company.interface';
import { CompanyService } from 'src/app/pages/companies/services/company.service';
import { DashboardsService } from 'src/app/pages/meu-dashboard/services/dashboards.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { SessionService } from 'src/app/shared/services/session.service';
import { IDashboardFilter, IDashboardShow } from '../../models/dashboard';
import { EOrdenacao } from 'src/app/shared/data/ordenacao.enum';

interface ImagesData {
  [key: string]: string;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  ERoleAdminString = ERoleAdminString;
  dashboards: IDashboardShow[] = [];
  dashboardsShow: IDashboardShow[] = [];

  companies: ICompany[] = [];
  companyId?: string = '';
  sessionCompanyId?: string = '';
  // activeImage: string = 'https://app-olive-themes.s3.amazonaws.com/Gráfico-Atestados.png';
  // images: ImagesData = {
  //   Riscos: 'https://app-olive-themes.s3.amazonaws.com/Grafico-Riscos.png',
  //   Atestados: 'https://app-olive-themes.s3.amazonaws.com/Gráfico-Atestados.png',
  //   'Cartão Oliv-e': 'https://app-olive-themes.s3.amazonaws.com/Grafico-Cartoes.png',
  //   'Idade Biológica': 'https://app-olive-themes.s3.amazonaws.com/Grafico-idadeBiologica.png',
  //   'Dr. Oliv-e': 'https://app-olive-themes.s3.amazonaws.com/Grafico-Dr-Olive.png',
  //   'Consultas e Telemedicina': 'https://app-olive-themes.s3.amazonaws.com/Grafico-telemedicina.png',
  //   Exames: 'https://app-olive-themes.s3.amazonaws.com/Grafico-Exames.png'
  // };

  activeDash = 'risk';

  isLoading = true;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly dashboardsService: DashboardsService,
    private readonly sessionService: SessionService,
    private readonly companyService: CompanyService
  ) { }

  ngOnInit(): void {
    this.fillDashboards();
    this.sessionCompanyId = this.sessionService.getSession().companyId;
  }

  changeDash(newActiveDash: string): void {
    this.activeDash = newActiveDash;
    // this.activeImage = this.images[newActiveDash];
  }

  sanitize(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  load(): void {
    this.isLoading = false;

    document.querySelectorAll('iframe')?.forEach((iframe) => {
      if (iframe.removeAllListeners) {
        iframe.removeAllListeners('load');
      }
    });
  }

  changeTabsByCompanyId(): void {
    this.dashboardsShow = this.companyId
      ? this.dashboards.filter((dash) => dash.companyId === this.companyId)
      : this.dashboards.slice();

    this.activeDash = this.dashboardsShow[0].tabName ?? 'Sem Dashboards';
  }

  private fillDashboards(): void {
    const companyId = this.sessionService.getSession().companyId;
    const partnerId = this.sessionService.getSession().partnerId;
    const accountRole = this.sessionService.getSession().accountRole;

    const filtros: IDashboardFilter = {
      pageNumber: 0,
      pageSize: 9999,
      active: true
    };

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }
    if (partnerId) {
      filtros.partnerId = partnerId;
    }
    if (companyId) {
      filtros.companyId = companyId;
    }

    this.dashboardsService.listarMyDashboardsByFilter(filtros).subscribe((res) => {
      this.dashboards = res.data;

      this.dashboardsShow = res.data;

      this.activeDash = this.dashboardsShow[0].tabName ?? 'Sem Dashboards';

      this.carregarEmpresas();
    });
  }

  private carregarEmpresas(): void {
    const filtros: IListByFilterEmpresas = {
      orderBy: EOrdenacao.AlfabeticaAZ,
      pageNumber: 0,
      pageSize: 9999
    };

    const partnerId = this.sessionService.getSession().partnerId;
    const companyId = this.sessionService.getSession().companyId;
    const accountRole = this.sessionService.getSession().accountRole;

    if (partnerId) {
      filtros.partnerId = partnerId;
    }

    if (companyId) {
      filtros.companyId = companyId;
    }

    if (accountRole) {
      filtros.accountRole = parseInt(accountRole);
    }

    this.companyService.listarTodasEmpresas(filtros).subscribe((resposta) => {
      this.companies = resposta.data.filter((company) => this.dashboards.some((dash) => dash.companyId === company.id));
    });
  }
}
